import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export const ReloadDialog = ({open, handleClose}) => {

  const reload = () => {
    handleClose();
    window.location.reload()
  }

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="reload-dialog-title"
        aria-describedby="reload-dialog-description"
      >
        <DialogTitle id="reload-dialog-title">
          {"Submission Cancelled"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="reload-dialog-description">
          You have canceled your payment card submission. If you would like to submit a payment card please try again.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={reload} autoFocus>
            CLOSE
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export const useReloadDialog = () => {
  const [openDialog, setDialog] = useState(false);

  const handleClose = () => {
    setDialog(false);
  };

  const openReloadDialog = () => {
    setDialog(true);
  }

  return (
    [
      () => <ReloadDialog open={openDialog} handleClose={handleClose}/>,
      openReloadDialog
    ]
  )
  
}